import { create } from 'zustand';

export interface RefreshItem {
    refreshKey: string,
    refreshId?: number,
    item?: any
}

const refreshKeys = {
    refreshRequestHotelManager: 0,

    refreshRequestHotelAllotmentList: 0,

    refreshRequestHotelAllotmentStock: 0,

    refreshRequestAllotmentStockRecalc: 0,

    refreshRequestHotelAllotmentContracts: 0,

    refreshRequestAllotmentEditRequestAllotmentStock: 0,
    refreshRequestAllotmentsListRequestAllotmentStock: 0,

    refreshClientAllotmentDetail: 0,
    refreshRequestAllotmentClient: 0,
    refreshRequestAllotmentHeader: 0,

    refreshRequestPriority:0,
    refreshRequestHotelPriority: 0
}



interface StoreState {
    refresh: {[locale: string] : number },
    refreshItem?: RefreshItem,
}

interface StoreActions {
    createRefresh: (item: RefreshItem) => void
    executeRefreshItem: (timeToken: number, itemId: number, method:(...args: any) => void) => void
    executeRefreshList: (timeToken: number, method:(...args: any) => void) => void
}

const useRefreshStore = create<StoreState & StoreActions>((set, get) => ({
    refresh: refreshKeys,
    refreshItem: null,

    createRefresh: (item) => {
        const newRefresh = {...get().refresh};
        newRefresh[item.refreshKey] = Date.now();
        set({
            refresh:newRefresh,
            refreshItem: item
        });
    },

    executeRefreshItem: (timeToken, itemId, method) => {
        if(get().refresh[get().refreshItem?.refreshKey] > timeToken &&  itemId == get().refreshItem?.refreshId) {
            method()
        }
    },

    executeRefreshList: (timeToken, method) => {
        if(get().refresh[get().refreshItem?.refreshKey] > timeToken) {
            method()
        }
    }

}));

export default useRefreshStore;